<template>
  <button
    class="d-flex align-items-center justify-content-center btn btn-outline-primary btn-add font-weight-bolder"
    @click="$emit('click')"
  >
    +
  </button>
</template>

<script>
/**
 * @description Composante permettant d'ajouter un bouton pré-fait destiné à l'ajout d'objet
 * @author Alexandre Gallant
 */
export default {
  name: "GenericBtnAdd"
};
</script>

<style lang="scss" scoped>
button {
  height: 39px !important;
  width: 39px !important;
  font-size: 25px !important;
  line-height: 50% !important;
}
</style>
